import { gql, useMutation } from "@apollo/client";

const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($currentPassword: String!, $newPassword: String!) {
    updateMemberPassword(
      input: { current: $currentPassword, password: $newPassword }
    ) {
      id
    }
  }
`;

const useUpdatePassword = () => {
  return useMutation(UPDATE_PASSWORD);
};

export default useUpdatePassword;
